<template>
  <div class="introduce">
    <div class="title">{{ title }}</div>
    <div class="content">
      <div>
        <img
          :src="img"
          alt=""
        />
        <img
          :src="img2"
          alt=""
        />
      </div>
      <div class="desc">{{ desc }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '产品介绍'
    },
    desc: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    img2: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      data: {
        menu_list: []
      }
    };
  },
  created() {},
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.introduce {
  padding: 1px;
  width: 1200px;
  height: 626px;
  margin: 0 auto;
  .title {
    font-size: 42px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.6);
    line-height: 63px;
    text-align: center;
    margin-top: 42px;
  }
  .content {
    margin-top: 50px;
    > div:nth-child(1) {
      display: flex;
      justify-content: space-between;
      > img:nth-child(1) {
        width: 420px;
        height: 290px;
      }
      > img:nth-child(2) {
        width: 740px;
        height: 290px;
      }
    }
    .desc {
      font-size: 24px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.6);
      line-height: 40px;
      margin-top: 37px;
    }
  }
}
@media (max-width: 1000px) {
  .introduce{
    padding: 0 48px;
    width: 100%;
    .title{
      font-size: 44px;
      margin-top: 80px;
    }
    .content{
      margin-top: 80px;
      div:nth-child(1){
        img:nth-child(1) {
          width: 230px;
          height: 160px;
          margin-right: 12px;
        }
        img:nth-child(2) {
          width: 410px;
          height: 160px;
        }
      }
      .desc{
        margin-top: 40px;
        font-size: 28px;
        padding-bottom: 80px;
        color: #5E5E5E;
        letter-spacing: 0;
        text-align: justify;
        line-height: 40px;
        font-weight: 400;
      }
    }
  }
}
</style>
